export function sellerAdvisoryVacantLandCP826() {
return [   // Release 2026-09-03 13:58:51
 
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.76,
   height: 10.08
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 141.182,
   left: 176.074,
   width: 372.546,
   height: 13.491
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 168.019,
   left: 176.073,
   width: 372.547,
   height: 13.491
}
,
{
   page: 0,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 194.855,
   left: 176.073,
   width: 372.547,
   height: 13.491
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 222.037,
   left: 176.073,
   width: 372.547,
   height: 13.491
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.76,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.76,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.76,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 47.4,
   left: 156.84,
   width: 383.76,
   height: 11.16
}
,
{
   page: 4,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 368.48,
   left: 72.0,
   width: 378.24,
   height: 15.054
}
,
{
   page: 4,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 368.48,
   left: 455.4,
   width: 76.8,
   height: 15.054
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
] }
